<template>
  <b-row class="dashboard-indicadores-historico-plazos">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">{{ titulo }}</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresPlazosClientes" 
          :fields="indicadoresPlazosClientesFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(plazoObjetivo)="data">
          {{ data.item.plazoObjetivo }}
          <!-- {{ data.item.plazoObjetivo | numero(2, true) }} -->
        </template>
        <template v-slot:cell(plazoActual)="data">
          {{ data.item.plazoActual }}
          <!-- {{ data.item.plazoActual | numero(2, true) }} -->
        </template>
        <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item 
                @click.stop="exportarComprobantes(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Comprobantes</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    showTitulo: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      titulo: 'Plazos de Cobro',
      indicadoresPlazosClientes: [],
      indicadoresPlazosClientesFields: [
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'plazoObjetivo',
          class: 'text-right'
        },
        { 
          key: 'plazoActual',
          label: 'Plazo Real',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      tableBusy: false
    }
  },
  methods: {
    getIndicadores() {
      this.tableBusy = true;
      this.$store.dispatch('resultadosAdministracion/getIndicadoresPlazosClientesHistorico')
        .then(() => {
          this.indicadoresPlazosClientes = this.$store.getters['resultadosAdministracion/indicadoresPlazosClientesHistorico'];
          this.tableBusy = false;
        });
    },
    exportarComprobantes(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
      }
      this.showSpinner();
      this.$store.dispatch('resultadosAdministracion/getIndicadorPlazosClientesHistoricoComprobantes', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosAdministracion/resultadosIndicadorPlazosClientesComprobantes'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportXLSResumenPlazosClientes(rptComprobantes);
          } else {
            console.log('No hay datos para exportar.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  }
}
</script>

<style>
</style>